import { Form, Formik } from 'formik';
import Input from '@/components/ui/inputFormik';
import AskForgot from '@/components/ui/buttons/ask-forgot';
import AskToggle from '@/components/ui/buttons/ask-toggle';
import InputPassword from '@/components/ui/inputFormik/input-password';
import { loginValidation } from '@/utils/validation/auth';
import { useLocale } from 'use-intl';
import AuthStatment from '../auth-statment';
import useCheckout from '@/store/checkout.store';
import useSearchParams from '@/hooks/useSearchParams';
import { useRouter } from 'next/navigation';
import TurnstileRecaptcha from '@/components/turnstile/TurnstileRecaptcha';
import { useTurnstile } from 'react-turnstile';
import { logInByEmail } from '@/services/auth';
import { signInHandler } from '@/utils/auth';

const EmailLogin = ({ setAuth, t }) => {
  const locale = useLocale();
  const { clearCheckout, setActiveShippingMethod } = useCheckout();
  const { getFilterObj } = useSearchParams();
  const { push } = useRouter();
  const turnstile = useTurnstile();

  const handleLogin = async (
    values,
    { setSubmitting, setFieldError, setFieldValue }
  ) => {
    const response = await logInByEmail(
      values?.email,
      values?.password,
      values?.recaptchaToken
    );

    if (!response?.data || response?.error?.success === 'false') {
      turnstile.reset();
      setFieldValue('recaptchaToken', '');
      setTimeout(() => {
        setFieldError(
          'password',
          locale === 'en'
            ? 'Email or password is wrong, please try again'
            : 'خطأ فى البريد الالكترونى او كلمة المرور'
        );
      });
      return setSubmitting(false);
    }

    await signInHandler({
      response,
      rememberMe: values?.rememberMe,
      locale,
      clearCheckout,
      setActiveShippingMethod,
      setAuth,
      getFilterObj,
      push,
      loginType: 'email',
      turnstile,
    });

    setSubmitting(false);
  };

  return (
    <>
      <AuthStatment
        title={t('If you have an account,')}
        description={t('Log in using your email address')}
      />
      <Formik
        onSubmit={handleLogin}
        validationSchema={loginValidation(t)}
        enableReinitialize
        initialValues={{
          email: '',
          password: '',
          rememberMe: false,
          recaptchaToken: '',
        }}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className='flex flex-col gap-2 px-2 lg:gap-4 lg:px-8'>
            <Input name='email' title={t('Email')} id='email' />
            <InputPassword
              name='password'
              id='password'
              title={t('Password')}
            />
            <AskForgot t={t} setAuth={setAuth} />

            <TurnstileRecaptcha
              action='email-login'
              className='flex items-center justify-center p-2'
              onVerify={(value) => {
                setFieldValue('recaptchaToken', value);
              }}
            />

            <button
              type='submit'
              disabled={isSubmitting}
              className='bg-primary flex w-full cursor-pointer items-center justify-center gap-3 rounded-lg py-1 font-bold text-white hover:bg-red-600/70 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600 max-lg:text-sm max-sm:my-1.5 max-sm:h-9 lg:py-1.5'
            >
              {isSubmitting && (
                <span className='border-primary-500 size-4 animate-spin rounded-full border-t border-r py-1 max-lg:size-2' />
              )}

              {t('Login')}
            </button>
            <AskToggle t={t} setAuth={setAuth} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default EmailLogin;
